/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Admin_User_List_HitsInputs */

const en_admin_user_list_hits = /** @type {(inputs: Admin_User_List_HitsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} matches`)
};

const de_admin_user_list_hits = /** @type {(inputs: Admin_User_List_HitsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} Treffer`)
};

/**
* | output |
* | --- |
* | "{count} matches" |
*
* @param {Admin_User_List_HitsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_user_list_hits = /** @type {((inputs: Admin_User_List_HitsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_User_List_HitsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_user_list_hits(inputs)
	return en_admin_user_list_hits(inputs)
});